import React from "react"
import PropTypes from "prop-types"

import { EnumSelectCell } from "app/static/frontend/sheets/components/cells/MantineCells/EnumSelectCell"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

export const YesNoNullCell = ({ children, ...props }: any) => {
    // Pretend to be a djangio enum to use the nifty EnumSelectCell
    const items = [
        { label: "Yes", value: true, display: "Yes" },
        { label: "No", value: false, display: "No" },
        { label: "Blank", value: null, display: "" },
    ]
    const options = { items: () => items }

    // map items to values
    const getOptions = (val) => (val === null || val === undefined ? items[2] : items[Number(!val)])
    const style = { width: "100%" }

    if (props.editing && props.cellIsEditable) {
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div
                style={style}
                // neccessary because the Select onClick() event propagates down to the SheetCell onClick() every time we click on a select,
                // which re-calls clickCell() after the unclickCell() action creator is fired in patchColumnData of sheet-action-creators
                // Since it is not possible to pass an onClick prop down to a react-select component, this is necessary
                // https://github.com/JedWatson/react-select/issues/532
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                }}
            >
                <EnumSelectCell choices={options} item={getOptions(children)} clearable {...props} />
            </div>
        )
    } else {
        return <CellWrapper {...props}>{getOptions(children).display}</CellWrapper>
    }
}

YesNoNullCell.propTypes = {
    children: PropTypes.bool,
}
YesNoNullCell.defaultProps = {
    cellIsEditable: true,
}

export default YesNoNullCell
